import React, { useState, useEffect } from "react";
import ContactStack from '../ContactPage/ContactPage';
import { Container, Row, Col } from 'react-bootstrap';
import { AnimatePresence } from 'framer-motion';
import Navbar from "../Navigation/Navigation";
import whatsappImg from "../../assets/whatsapp.png";
import { Mail, Phone, MapPin } from 'lucide-react';

const FullContact = () => {
  const [showContact, setShowContact] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Address for the Map
  const mapAddress = "Saravanan Towers, Millennium Town Phase 2, Vanagaram, Chennai, Tamil Nadu 600095";
  const encodedAddress = encodeURIComponent(mapAddress);
  // Using the standard Google Maps Embed API format
  const mapSrc = `https://maps.google.com/maps?q=${encodedAddress}&t=&z=15&ie=UTF8&iwloc=B&output=embed`;

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 991);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="contact-page-container" style={{ position: 'relative', overflow: 'hidden', background: '#fff', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <style>{`
        .contact-info-link {
          color: #0D1F46;
          text-decoration: none;
          transition: all 0.25s ease-in-out;
          display: inline-block;
        }
        .contact-info-link:hover {
          color: #009BD8 !important;
          transform: translateX(3px);
        }
        .contact-info-card {
          transition: transform 0.3s ease;
        }
        .contact-info-card:hover {
          transform: translateY(-2px);
        }
      `}</style>
      <Navbar />

      <section className="flex-grow-1 d-flex align-items-center pt-5 mt-5">
        <Container fluid className="px-lg-5">
          {/* Main Content Row */}
          <Row className="align-items-center mb-5" >
            {/* Left Column: Heading & Description */}
            <Col lg={5} md={12} className="text-left">
              <h1 className="text-5xl md:text-7xl font-bold mb-3 text-[#001233] leading-[0.85]">
                Let’s Ascent <br /> Together
              </h1>

              <p style={{
                color: '#0D1F46',
                fontSize: isMobile ? '1.1rem' : '1.2rem',
                whiteSpace: isMobile ? 'normal' : 'nowrap',
                marginBottom: '2.5rem'
              }}>
                From strategy to execution, we help brands grow with clarity.
              </p>

              <button
                onClick={() => setShowContact(true)}
                style={{
                  backgroundColor: '#0D1F46',
                  color: '#fff',
                  padding: '14px 45px',
                  borderRadius: '50px',
                  border: 'none',
                  fontWeight: '600'
                }}
              >
                Contact Us
              </button>
            </Col>

            {/* Right Column: Map with Pin and Address Info */}
            <Col lg={7} md={12} className="mt-5 mt-lg-0">
              <div className="shadow-sm rounded-4 overflow-hidden" style={{ border: '1px solid #eee' }}>
                <iframe
                  title="Ascent Business World Location"
                  src={mapSrc}
                  width="100%"
                  height={isMobile ? "250" : "400"}
                  style={{ border: 0, display: 'block' }}
                  allowFullScreen=""
                  loading="lazy"
                ></iframe>
              </div>
            </Col>
          </Row>

          {/* Bottom Info Row */}
          <Row className="border-top pt-4 mt-auto align-items-stretch" style={{ borderTop: '1px solid #eee' }}>
            <Col lg={3} md={6} xs={12} className="mb-4 mb-lg-0">
              <div className="contact-info-card" style={{ display: 'flex', gap: '12px', alignItems: 'center', height: '100%' }}>
                <Mail size={20} color="#0D1F46" style={{ flexShrink: 0 }} />
                <a href="mailto:admin@ascentbw.com" className="contact-info-link" style={{ fontSize: '0.95rem', color: '#000', fontWeight: '500', wordBreak: 'break-all' }}>
                  admin@ascentbw.com
                </a>
              </div>
            </Col>

            <Col lg={3} md={6} xs={12} className="mb-4 mb-lg-0">
              <div className="contact-info-card" style={{ display: 'flex', gap: '12px', alignItems: 'center', height: '100%' }}>
                <Phone size={20} color="#0D1F46" style={{ flexShrink: 0 }} />
                <a href="tel:+917540001028" className="contact-info-link" style={{ fontSize: '0.95rem', color: '#000', fontWeight: '500' }}>
                  75400 01028
                </a>
              </div>
            </Col>

            <Col lg={4} md={6} xs={12} className="mb-4 mb-md-0">
              <div className="contact-info-card" style={{ display: 'flex', gap: '12px', alignItems: 'flex-start', height: '100%' }}>
                <MapPin size={20} color="#0D1F46" style={{ flexShrink: 0, marginTop: '2px' }} />
                <a 
                  href="https://maps.google.com/?q=Saravanan+Towers,+Millennium+Town+Phase+2,+Vanagaram,+Chennai,+Tamil+Nadu+600095"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact-info-link"
                  style={{ fontSize: '0.9rem', color: '#000', fontWeight: '500', lineHeight: '1.4' }}
                >
                  Plot No:2, Saravanan Towers, 2nd Floor, Millennium Town Phase 2, Vanagaram, Chennai 600095, Tamilnadu, India.
                </a>
              </div>
            </Col>

            <Col lg={2} md={6} xs={12}>
              <div className="contact-info-card" style={{ display: 'flex', gap: '12px', alignItems: 'flex-start', height: '100%' }}>
                <MapPin size={20} color="#0D1F46" style={{ flexShrink: 0, marginTop: '2px' }} />
                <a 
                  href="https://maps.google.com/?q=Selangor,+Malaysia"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact-info-link"
                  style={{ fontSize: '0.9rem', color: '#000', fontWeight: '500', lineHeight: '1.4' }}
                >
                  Selangor, Malaysia
                </a>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <AnimatePresence>
        {showContact && (
          <ContactStack onClose={() => setShowContact(false)} />
        )}
      </AnimatePresence>

      {/* Fixed WhatsApp Icon */}
      <a
        href="https://wa.me/7540001028"
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          position: "fixed",
          bottom: "30px",
          right: "20px",
          zIndex: 9999,
          cursor: "pointer",
        }}
      >
        <img
          src={whatsappImg}
          alt="WhatsApp Chat"
          style={{
            width: "60px",
            height: "60px",
            borderRadius: "50%",
          }}
        />
      </a>
    </div>
  );
};

export default FullContact;